import AppRouter from "./Router";

export default function App() {
  return <AppRouter />;
}
